import { Component, OnInit, Input, OnDestroy, SimpleChanges } from "@angular/core";
import { PermissionUrlService } from "../../../services/permissions.service"; //"./../../../shared/services/permissions.service";
import { OrderHighlightService } from "./order-status.service";
import { GenericUtils } from './../../../utilities/generic-utils';
import { LoaderService } from './../../../../core/services/loader.service';
import * as DUMMY_DATA from "./settings";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ActivatedRoute, Params } from "@angular/router";
import { BroadcasterService } from "../../../../core/services/broadcaster.service";
import { CommonService } from "../../../../shared/services";

@Component({
  selector: "order-status-highlight",
  templateUrl: "./order-status-highlight.component.html",
  styleUrls: ["./order-status-highlight.component.scss"],
  providers: [OrderHighlightService]
})
export class OrderStatusHighlightComponent implements OnInit, OnDestroy {
  @Input() PERMISSIONS = [];
  @Input() TITLE = "";
  @Input() API = [];
  @Input() TEXTS = [];
  @Input() CONFIG = {};
  @Input() FILTERS;
  highlightData = {};
  highlightLoader = true;
  deviceWidth = window.innerWidth;
  private unsubscribe: Subject<void> = new Subject();

  constructor(
    private WIDGET_PERMISSIONS: PermissionUrlService,
    private orderHighlightService: OrderHighlightService,
    private utils: GenericUtils,
    private loader: LoaderService,
    private activateRoute: ActivatedRoute,
    private broadcaster: BroadcasterService,
    private commonService: CommonService
  ) { }


  ngOnChanges(changes: SimpleChanges) {
    this.getData();

  }


  ngOnInit() {
    // if (this.API) {
    //   const intiFilter = JSON.parse(JSON.stringify(this.FILTERS));
    //   this.activateRoute.queryParams.pipe(takeUntil(this.unsubscribe)).subscribe((params: Params) => {
    //     if (Object.keys(params).length) {
    //       this.highlightData = {};
    //       this.highlightLoader = true;
    //       this.FILTERS = this.commonService.getFiltersParams(params, this.FILTERS);
    //       this.getData();
    //     } else {
    //       this.highlightData = {};
    //       this.highlightLoader = true;
    //       this.FILTERS = JSON.parse(JSON.stringify(intiFilter));
    //       this.getData();
    //     }
    //   })
    // }
  }

  getData() {
    let queryParams = { ...this.FILTERS };
    const fcCode = queryParams['origin_fc_code'];
    if (fcCode) {
      queryParams['origin_fc_code'] = fcCode.split(' / ')[1] ? fcCode.split(' / ')[1] : fcCode;

    }
    queryParams.order_create_date__start = this.utils.convertDateToUTC(queryParams.order_create_date__start);
    queryParams.order_create_date__end = this.utils.convertDateToUTC(queryParams.order_create_date__end);
    this.orderHighlightService.getDataFromApi(this.API, queryParams).pipe(takeUntil(this.unsubscribe)).subscribe(response => {

      const responseDataKey = {};
      if (response && response['data'] && Object.keys(response['data']).length) {
        if (response['data']['cancelled']) {
          response['data'].total = response['data']['total'] - response['data']['cancelled']
        }
        Object.keys(response['data']).map(key => {
          responseDataKey[key] = this.utils.amountIndianUnit(response['data'][key]);
        });
        this.highlightData = responseDataKey;
      } else {
        this.highlightData = DUMMY_DATA.data;
        this.highlightData = { ...DUMMY_DATA.data, 'dummy': true };
      }

      this.highlightLoader = false;
    }, error => {
      this.highlightData = { ...DUMMY_DATA.data, 'error': true };
      this.highlightLoader = false;
    });
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
